var map = {
	"./brands-collections-results.de-CH.json": 1257,
	"./brands-collections-results.de-DE.json": 1258,
	"./brands-collections-results.en-CA.json": 1259,
	"./brands-collections-results.en-GB.json": 1260,
	"./brands-collections-results.en-IN.json": 1261,
	"./brands-collections-results.en-ME.json": 1262,
	"./brands-collections-results.en-US.json": 1263,
	"./brands-collections-results.es-EM.json": 1264,
	"./brands-collections-results.es-ES.json": 1265,
	"./brands-collections-results.fr-BE.json": 1266,
	"./brands-collections-results.fr-CA.json": 1267,
	"./brands-collections-results.fr-CH.json": 1268,
	"./brands-collections-results.nl-BE.json": 1269,
	"./brands-collections-results.nl-NL.json": 1270,
	"./brands-collections-results.pl-PL.json": 1271,
	"./brands-collections-results.pt-BR.json": 1272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1256;